import {lazy} from "react";
import ProtectedRoute from "components/ProtectedRoute";
import LandingPage from "views/public/Landing";
import AboutPage from "views/public/About";
import PublicJobs from "views/public/Jobs";
import PublicJobDetail from "views/public/JobDetail";
import PublicCompanies from "views/public/Companies";
import PublicCompanyDetail from "views/public/CompanyDetail";
import PrivacyPolicy from "./views/public/Privacy";
import MarketplacePage from "./views/public/Marketplace";
import SuppliersPage from "./views/public/Suppliers";
import TrainingPage from "./views/public/Training";

const Index = lazy(() => import("views/Dashboard"));
const Signup = lazy(() => import("views/auth/Signup"));
const Login = lazy(() => import("views/auth/Login"));
const EmailVerification = lazy(() => import("views/auth/EmailVerification"));
const Users = lazy(() => import("views/Users"));
const Companies = lazy(() => import("views/Companies"));
const SystemConfig = lazy(() => import("views/SystemConfig"));
const Settings = lazy(() => import("views/Settings"));
const Profile = lazy(() => import("views/Profile"));
const Chats = lazy(() => import("views/Chats"));
const EmployerDashboard = lazy(() => import("views/employer/EmployerDashboard"));
const JobPosts = lazy(() => import("views/employer/JobPosts"));
const EmployerProducts = lazy(() => import("views/employer/Products"));
const JobPostForm = lazy(() => import("views/employer/JobPostForm"));
const EditJobPost = lazy(() => import("views/employer/EditJobPost"));
const Applications = lazy(() => import("views/employer/Applications"));
const ApplicationDetail = lazy(() => import("views/employer/ApplicationDetail"));
const EmployerProfile = lazy(() => import("views/employer/EmployerProfile"));
const EmployerSettings = lazy(() => import("views/employer/EmployerSettings"));
const Talent = lazy(() => import("views/employer/Talent"));
const TalentDetail = lazy(() => import("views/employer/TalentDetail"));
const AdminJobPosts = lazy(() => import("views/admin/AdminJobPosts"));
const AdminJobPostForm = lazy(() => import("views/admin/AdminJobPostForm"));
const AdminEditJobPost = lazy(() => import("views/admin/AdminEditJobPost"));
const AdminJobDetail = lazy(() => import("views/admin/AdminJobDetail"));
const AdminTalentProfile = lazy(() => import("views/admin/AdminTalentProfile"));
const UserDetail = lazy(() => import("views/admin/UserDetail"));
const ContactInbox = lazy(() => import("views/admin/ContactInbox"));
const Announcements = lazy(() => import("views/Announcements"));
const CompanyDetail = lazy(() => import("views/admin/CompanyDetail"));
const AdminProducts = lazy(() => import("views/admin/AdminProducts"));
const ForgotPassword = lazy(() => import("views/auth/ForgotPassword"));

const routes = [
  // Admin Routes
  {
    path: "/index",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: (
      <ProtectedRoute requiredRole="admin">
        <Index />
      </ProtectedRoute>
    ),
    layout: "/admin",
    requiredRole: "admin",
  },
  {
    path: "/users",
    name: "Users",
    icon: "fas fa-users text-info",
    component: (
      <ProtectedRoute requiredRole="admin">
        <Users />
      </ProtectedRoute>
    ),
    layout: "/admin",
    requiredRole: "admin",
  },


  {
    path: "/profile",
    name: "User Profile",
    icon: "ni ni-single-02 text-yellow",
    component: (
      <ProtectedRoute requiredRole="admin">
        <Profile />
      </ProtectedRoute>
    ),
    layout: "/admin",
    requiredRole: "admin",
  },
  {
    path: "/companies",
    name: "Companies",
    icon: "ni ni-bullet-list-67 text-purple",
    component: (
      <ProtectedRoute requiredRole="admin">
        <Companies />
      </ProtectedRoute>
    ),
    layout: "/admin",
    requiredRole: "admin",
  },
  {
    path: "/products",
    name: "Products",
    icon: "fas fa-box text-success",
    component: (
      <ProtectedRoute requiredRole="admin">
        <AdminProducts />
      </ProtectedRoute>
    ),
    layout: "/admin",
    requiredRole: "admin",
  },
  {
    path: "/company/:id",
    name: "Company Detail",
    icon: "ni ni-bullet-list-67 text-purple",
    component: (
      <ProtectedRoute requiredRole="admin">
        <CompanyDetail />
      </ProtectedRoute>
    ),
    layout: "/admin",
    hidden: true,
    requiredRole: "admin",
  },
  {
    path: "/talent/:userId",
    name: "Talent Profile",
    icon: "fas fa-user-graduate text-info",
    component: (
      <ProtectedRoute requiredRole="admin">
        <AdminTalentProfile />
      </ProtectedRoute>
    ),
    layout: "/admin",
    hidden: true,
    requiredRole: "admin",
  },
  {
    path: "/user/:id",
    name: "User Detail",
    icon: "fas fa-user text-info",
    component: (
      <ProtectedRoute requiredRole="admin">
        <UserDetail />
      </ProtectedRoute>
    ),
    layout: "/admin",
    hidden: true,
    requiredRole: "admin",
  },
  {
    path: "/job-posts",
    name: "Job Posts",
    icon: "ni ni-briefcase-24 text-info",
    component: (
      <ProtectedRoute requiredRole="admin">
        <AdminJobPosts />
      </ProtectedRoute>
    ),
    layout: "/admin",
    requiredRole: "admin",
  },
  {
    path: "/chats",
    name: "Messages",
    icon: "ni ni-chat-round text-primary",
    component: (
      <ProtectedRoute requiredRole="admin">
        <Chats />
      </ProtectedRoute>
    ),
    layout: "/admin",
    requiredRole: "admin",
  },
  {
    path: "/announcements",
    name: "Announcements",
    icon: "fas fa-bullhorn text-warning",
    component: (
      <ProtectedRoute requiredRole="admin">
        <Announcements />
      </ProtectedRoute>
    ),
    layout: "/admin",
    requiredRole: "admin",
  },
  {
    path: "/contact-inbox",
    name: "Contact Inbox",
    icon: "fas fa-inbox text-info",
    component: (
      <ProtectedRoute requiredRole="admin">
        <ContactInbox />
      </ProtectedRoute>
    ),
    layout: "/admin",
    hidden: true,
    requiredRole: "admin",
  },
  {
    path: "/post-job",
    name: "Post New Job",
    icon: "ni ni-cloud-upload-96 text-success",
    component: (
      <ProtectedRoute requiredRole="admin">
        <AdminJobPostForm />
      </ProtectedRoute>
    ),
    layout: "/admin",
    hidden: true,
    requiredRole: "admin",
  },
  {
    path: "/job-post/:id",
    name: "Job Post Detail",
    icon: "ni ni-briefcase-24 text-info",
    component: (
      <ProtectedRoute requiredRole="admin">
        <AdminJobDetail />
      </ProtectedRoute>
    ),
    layout: "/admin",
    hidden: true,
    requiredRole: "admin",
  },
  {
    path: "/job-post/:id/edit",
    name: "Edit Job Post",
    icon: "ni ni-cloud-upload-96 text-success",
    component: (
      <ProtectedRoute requiredRole="admin">
        <AdminEditJobPost />
      </ProtectedRoute>
    ),
    layout: "/admin",
    hidden: true,
    requiredRole: "admin",
  },
  // Employer Routes
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: (
      <ProtectedRoute requiredRole="employer">
        <EmployerDashboard />
      </ProtectedRoute>
    ),
    layout: "/employer",
    requiredRole: "employer",
  },
  {
    path: "/jobs",
    name: "Job Posts",
    icon: "ni ni-briefcase-24 text-info",
    component: (
      <ProtectedRoute requiredRole="employer">
        <JobPosts />
      </ProtectedRoute>
    ),
    layout: "/employer",
    requiredRole: "employer",
  },
  {
    path: "/products",
    name: "Products",
    icon: "fas fa-box text-success",
    component: (
      <ProtectedRoute requiredRole="employer">
        <EmployerProducts />
      </ProtectedRoute>
    ),
    layout: "/employer",
    requiredRole: "employer",
  },
  {
    path: "/talent",
    name: "Talent",
    icon: "fas fa-users text-success",
    component: (
      <ProtectedRoute requiredRole="employer">
        <Talent />
      </ProtectedRoute>
    ),
    layout: "/employer",
    requiredRole: "employer",
  },
  {
    path: "/talent/:talentId",
    name: "Talent Detail",
    icon: "ni ni-single-02 text-success",
    component: (
      <ProtectedRoute requiredRole="employer">
        <TalentDetail />
      </ProtectedRoute>
    ),
    layout: "/employer",
    hidden: true,
    requiredRole: "employer",
  },
  {
    path: "/post-job",
    name: "Post New Job",
    icon: "ni ni-cloud-upload-96 text-success",
    component: (
      <ProtectedRoute requiredRole="employer">
        <JobPostForm />
      </ProtectedRoute>
    ),
    layout: "/employer",
    hidden: true,
    requiredRole: "employer",
  },
  {
    path: "/job-post/:id",
    name: "Edit Job Post",
    icon: "ni ni-cloud-upload-96 text-success",
    component: (
      <ProtectedRoute requiredRole="employer">
        <EditJobPost />
      </ProtectedRoute>
    ),
    layout: "/employer",
    hidden: true,
    requiredRole: "employer",
  },
  {
    path: "/applications",
    name: "Applications",
    icon: "ni ni-single-copy-04 text-warning",
    component: (
      <ProtectedRoute requiredRole="employer">
        <Applications />
      </ProtectedRoute>
    ),
    layout: "/employer",
    hidden: true,
    requiredRole: "employer",
  },
  {
    path: "/job-post/:jobPostId/applications",
    name: "Job Post Applications",
    icon: "ni ni-single-copy-04 text-warning",
    component: (
      <ProtectedRoute requiredRole="employer">
        <Applications />
      </ProtectedRoute>
    ),
    layout: "/employer",
    hidden: true,
    requiredRole: "employer",
  },
  {
    path: "/job-post/:jobPostId/application/:applicationId",
    name: "Application Detail",
    icon: "ni ni-single-copy-04 text-warning",
    component: (
      <ProtectedRoute requiredRole="employer">
        <ApplicationDetail />
      </ProtectedRoute>
    ),
    layout: "/employer",
    hidden: true,
    requiredRole: "employer",
  },
  {
    path: "/profile",
    name: "Company Profile",
    icon: "ni ni-single-02 text-yellow",
    component: (
      <ProtectedRoute requiredRole="employer">
        <EmployerProfile />
      </ProtectedRoute>
    ),
    layout: "/employer",
    requiredRole: "employer",
  },

  {
    path: "/chats",
    name: "Messages",
    icon: "ni ni-chat-round text-primary",
    component: (
      <ProtectedRoute requiredRole="employer">
        <Chats />
      </ProtectedRoute>
    ),
    layout: "/employer",
    requiredRole: "employer",
  },

  // Auth Routes
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <Login />,
    layout: "/auth",
  },
  {
    path: "/signup",
    name: "Signup",
    icon: "ni ni-circle-08 text-pink",
    component: <Signup />,
    layout: "/auth",
  },
  {
    path: "/email-verification",
    name: "Email Verification",
    icon: "ni ni-email-83 text-info",
    component: <EmailVerification />,
    layout: "/auth",
  },
    {
    path: "/forgot-password",
    name: "Forgot Password",
    icon: "ni ni-key-25 text-info",
    component: <ForgotPassword />,
    layout: "/auth",
    hidden: true,
  },

  // System Routes - Admin
  {
    path: "/system-config",
    name: "System Config",
    icon: "fas fa-server text-default",
    component: (
      <ProtectedRoute requiredRole="admin">
        <SystemConfig />
      </ProtectedRoute>
    ),
    layout: "/admin",
    section: "system",
    requiredRole: "admin",
  },
  {
    path: "/settings",
    name: "Settings",
    icon: "ni ni-settings-gear-65 text-default",
    component: (
      <ProtectedRoute requiredRole="admin">
        <Settings />
      </ProtectedRoute>
    ),
    layout: "/admin",
    section: "system",
    requiredRole: "admin",
  },
  // System Routes - Employer
  {
    path: "/settings",
    name: "Settings",
    icon: "ni ni-settings-gear-65 text-default",
    component: (
      <ProtectedRoute requiredRole="employer">
        <EmployerSettings />
      </ProtectedRoute>
    ),
    layout: "/employer",
    section: "system",
    requiredRole: "employer",
  },

  //Public routes
  {
    path: "/",
    name: "Landing",
    component: <LandingPage />,
    layout: "/public",
  },
  {
    path: "/landing",
    name: "Landing",
    component: <LandingPage />,
    layout: "/public",
  },
  {
    path: "/about",
    name: "About",
    component: <AboutPage />,
    layout: "/public",
  },
  {
    path: "/jobs",
    name: "Jobs",
    component: <PublicJobs />,
    layout: "/public",
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: <PrivacyPolicy />,
    layout: "/public",
  },
  {
    path: "/job/:id",
    name: "Job Detail",
    component: <PublicJobDetail />,
    layout: "/public",
  },
  {
    path: "/companies",
    name: "Companies",
    component: <PublicCompanies />,
    layout: "/public",
  },
  {
    path: "/company/:id",
    name: "Company Detail",
    component: <PublicCompanyDetail />,
    layout: "/public",
  },
  {
    path: "/marketplace",
    name: "Energy Marketplace",
    component: <MarketplacePage />,
    layout: "/public",
  },
  {
    path: "/suppliers",
    name: "Suppliers",
    component: <SuppliersPage />,
    layout: "/public",
  },
  {
    path: "/training",
    name: "Training",
    component: <TrainingPage />,
    layout: "/public",
  },
];

export default routes;
